import { render, staticRenderFns } from "./doctor.vue?vue&type=template&id=7947eadb&scoped=true&"
import script from "./doctor.vue?vue&type=script&lang=js&"
export * from "./doctor.vue?vue&type=script&lang=js&"
import style0 from "./doctor.vue?vue&type=style&index=0&id=7947eadb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7947eadb",
  null
  
)

export default component.exports